import { createListenerMiddleware } from '@reduxjs/toolkit'
import {
  assignCategoryToBook,
  assignContributorToChapter,
  createBook,
  deleteBook,
  deleteCategory,
  deleteChapter,
  deleteContributor,
  fetchBookCategories,
  fetchBookChapters,
  fetchBooks,
  fetchCategories,
  fetchChapterContributors,
  fetchContributors,
  removeCategoryFromBook,
  removeContributorFromChapter,
} from './codex.slice'

export let listenerMiddleware = createListenerMiddleware()

listenerMiddleware.startListening({
  actionCreator: createBook.fulfilled,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(fetchBooks())
  },
})

listenerMiddleware.startListening({
  actionCreator: deleteBook.fulfilled,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(fetchBooks())
  },
})

listenerMiddleware.startListening({
  actionCreator: deleteChapter.fulfilled,
  effect: async (action, listenerApi) => {
    let state = listenerApi.getState() as any
    let bookID = state.codex.activeBook?.id
    if (bookID) {
      listenerApi.dispatch(fetchBookChapters(bookID))
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: deleteCategory.fulfilled,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(fetchCategories())
  },
})

listenerMiddleware.startListening({
  actionCreator: deleteContributor.fulfilled,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(fetchContributors())
  },
})

listenerMiddleware.startListening({
  actionCreator: removeCategoryFromBook.fulfilled,
  effect: async (action, listenerApi) => {
    let state = listenerApi.getState() as any
    let bookID = state.codex.activeBook?.id
    if (bookID) {
      listenerApi.dispatch(fetchBookCategories(bookID))
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: assignCategoryToBook.fulfilled,
  effect: async (action, listenerApi) => {
    let state = listenerApi.getState() as any
    let bookID = state.codex.activeBook?.id
    if (bookID) {
      listenerApi.dispatch(fetchBookCategories(bookID))
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: removeContributorFromChapter.fulfilled,
  effect: async (action, listenerApi) => {
    let chapterID = (action as any).meta?.arg?.chapterID
    if (chapterID) {
      listenerApi.dispatch(fetchChapterContributors(chapterID))
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: assignContributorToChapter.fulfilled,
  effect: async (action, listenerApi) => {
    let chapterID = (action as any).meta?.arg?.chapterID
    if (chapterID) {
      listenerApi.dispatch(fetchChapterContributors(chapterID))
    }
  },
})
